import { inject, injectable } from '@/inversify';
import { KEY } from '@/inversify.keys';

import type CompsetsApiService from '@/modules/compsets/compsets-api.service';

import type StoreFacade from '../common/services/store-facade';
import type CompsetsStore from './store/compsets.store';

@injectable()
export default class CompsetOnboardingService {
    @inject(KEY.CompsetsApiService) private compsetsApiService!: CompsetsApiService;
    @inject(KEY.StoreFacade) private storeFacade!: StoreFacade;

    readonly storeState: CompsetsStore = this.storeFacade.getState('CompsetsStore');

    get onboarding() {
        return this.storeState.onboarding;
    }

    createOnboardingCompset() {
        return this.compsetsApiService.createCompset(this.storeState.onboarding.data);
    }
}
